import { observer } from 'mobx-react';
import Loader from '../../../../Loader';
import { ImportedParticipantsResource } from '../../Store/Types';
import AddParticipantsToGroupForm from './AddParticipantsToGroupForm';
import AddParticipantsToGroupFormSuccess from './AddParticipantsToGroupFormSuccess';
import AddParticipantsToGroupFormStore from './AddParticipantsToGroupForm/Store';

interface Props {
  successfulParticipantsResource: ImportedParticipantsResource;
  addParticipantsToGroupFormStore: AddParticipantsToGroupFormStore;
}

function AddParticipantsToGroupFormState({
  successfulParticipantsResource,
  addParticipantsToGroupFormStore,
}: Props) {
  switch (addParticipantsToGroupFormStore.state.kind) {
    case 'error':
      return <></>;
    case 'ready':
    case 'ready-to-submit':
      return (
        <>
          <AddParticipantsToGroupForm
            successfulParticipantsResource={successfulParticipantsResource}
            addParticipantsToGroupFormStore={addParticipantsToGroupFormStore}
            state={addParticipantsToGroupFormStore.state}
          />
        </>
      );
    case 'submitting':
      return <Loader />;
    case 'success':
      return (
        <AddParticipantsToGroupFormSuccess
          length={addParticipantsToGroupFormStore.state.participants.length}
          label={addParticipantsToGroupFormStore.state.group.label}
        />
      );
  }
}

export default observer(AddParticipantsToGroupFormState);
